<div class="mx-4 mb-5 flex justify-end">
  <div class="align-center flex" *ngIf="checkout.status == 0">
    <div class="c-btn-group-rtl">
      <button
        class="rounded-md border border-primary-darkest p-1 text-primary-darkest"
        (click)="makePayment()">
        Make Payment
      </button>
    </div>
  </div>
</div>

<div class="invoice mx-4 rounded-xl border border-primary-md-dark p-5">
  <div class="header flex justify-between">
    <div class="mb-3 flex">
      <img
        src="/assets/images/logo-hb-sm.webp"
        alt="Happy Beauty"
        class="hb-logo" />
    </div>
    <div class="flex-item align-center text-right">
      <div class="title text-2xl uppercase">Invoice</div>
    </div>
  </div>
  <div class="subheader">
    <div class="mb-8 flex justify-between">
      <div class="flex-item">
        <div class="mb-2">
          <div class="heading text-primary-md-dark">Billed To</div>
          <div class="billed-to">{{ checkout.receiver_name }}</div>
          <div class="billed-to">{{ checkout.address }}</div>
        </div>
        <div class="block lg:hidden">
          <div class="mb-2">
            <div class="heading text-primary-md-dark">Date of Issue</div>
            <div>{{ checkout.formatted_transaction_time }}</div>
          </div>
          <div>
            <div class="heading text-primary-md-dark">Due Date</div>
            <div>{{ checkout.paymentDeadline }}</div>
          </div>
        </div>
      </div>
      <div class="flex-item hidden lg:block">
        <div class="mb-2">
          <div class="heading text-primary-md-dark">Date of Issue</div>
          <div>{{ checkout.formatted_transaction_time }}</div>
        </div>
        <div>
          <div class="heading text-primary-md-dark">Due Date</div>
          <div>{{ checkout.paymentDeadline }}</div>
        </div>
      </div>
      <div class="flex-item hidden lg:block">
        <div class="heading text-primary-md-dark">Invoince Number</div>
        <div>#{{ checkout.id }}</div>
      </div>
      <div class="flex-item text-right">
        <div class="mb-2 block lg:hidden">
          <div class="heading text-primary-md-dark">Invoince Number</div>
          <div>#{{ checkout.id }}</div>
        </div>
        <div>
          <div class="heading text-primary-md-dark">Amount</div>
          <div class="amount text-2xl">
            {{ checkout.grand_total | fcCurrency }}
          </div>
        </div>
      </div>
    </div>
  </div>
  <hr class="my-3 h-1 w-full bg-primary-md-dark" />
  <div class="body lg:text-right">
    <table width="100%" class="inv-table">
      <tr class="">
        <th width="40%" class="text-start text-primary-md-dark lg:text-right">
          Product
        </th>
        <th width="25%" class="text-start text-primary-md-dark lg:text-right">
          Price
        </th>
        <th width="10%" class="text-start text-primary-md-dark lg:text-right">
          Qty
        </th>
        <th width="25%" class="text-start text-primary-md-dark lg:text-right">
          Subtotal
        </th>
      </tr>
      <tr *ngFor="let line of lines" class="products">
        <td
          class="border border-white border-b-primary-dark py-4 lg:text-right">
          {{ line.product_name }}
          <span *ngIf="line.product_variant_name"
            ><br />Varian: {{ line.product_variant_name }}</span
          >
        </td>
        <td class="border border-white border-b-primary-dark">
          {{ line.unit_price | fcCurrency }}
        </td>
        <td class="border border-white border-b-primary-dark">
          {{ line.quantity }}
        </td>
        <td class="border border-white border-b-primary-dark">
          {{ line.total | fcCurrency }}
        </td>
      </tr>

      <tr>
        <td class="no-border space p-5" colspan="4"></td>
      </tr>
      <tr class="">
        <td class="no-border" colspan="2"></td>
        <td
          class="border border-white border-b-primary-dark py-4 lg:col-span-4">
          Subtotal
        </td>
        <td
          class="col-span-2 border border-white border-b-primary-dark lg:col-span-1">
          {{ checkout.subtotal - checkout.total_shipping_fee | fcCurrency }}
        </td>
      </tr>
      <tr>
        <td class="no-border" colspan="2"></td>
        <td
          class="border border-white border-b-primary-dark py-4 lg:col-span-2">
          Shipping Fee
        </td>
        <td
          class="col-span-2 border border-white border-b-primary-dark lg:col-span-1">
          {{ checkout.total_shipping_fee | fcCurrency }}
        </td>
      </tr>
      <tr>
        <td class="no-border" colspan="2"></td>
        <td
          class="border border-white border-b-primary-dark py-4 lg:col-span-2">
          Discount
        </td>
        <td
          class="col-span-2 border border-white border-b-primary-dark lg:col-span-1">
          -{{ checkout.discount | fcCurrency }}
        </td>
      </tr>
      <tr>
        <td class="no-border" colspan="2"></td>
        <td
          class="border border-white border-b-primary-dark py-4 lg:col-span-2"
          class="txt-p-md-dark no-border text-primary-md-dark">
          Grand Total
        </td>
        <td
          class="col-span-2 border border-white border-b-primary-dark lg:col-span-1"
          class="no-border">
          {{ checkout.grand_total | fcCurrency }}
        </td>
      </tr>
    </table>
  </div>
</div>
